// To simplify array
class WeezRoute {
    constructor(path, route) {
        if (!(route instanceof Function) || route.length !== 2) {
            throw new Error(`Second argument must be of type (endpoint, eventId) => 'string'`);
        }

        this.path = path;
        this.route = route;
    }
}

const routes = [
    new WeezRoute('/settings/sale_options', (endpoint, eventId) => `${endpoint}/billetterie_options.php?id_evenement=${eventId}`),
    new WeezRoute('/settings/seatmap', (endpoint, eventId) => `${endpoint}/seating/seatingchart/${eventId}`),
    new WeezRoute('/communicate/vouchers', (endpoint, eventId) => `${endpoint}/billetterie_codes_reduction.php?id_evenement=${eventId}`),
    // new WeezRoute('/communicate/indexing', (endpoint, eventId) => `${endpoint}/minisite_referencement.php?id_evenement=${eventId}`),
    new WeezRoute('/communicate/invitation', (endpoint, eventId) => `${endpoint}/event/invitation/${eventId}`),
    new WeezRoute('/channels/widgetRedirect', (endpoint, eventId) => `${endpoint}/billetterie_widget.php?id_evenement=${eventId}`),
    //new WeezRoute('/channels/facebook', (endpoint, eventId) => `${endpoint}/communiquer_facebook.php?id_evenement=${eventId}`),
    new WeezRoute('/channels/page', (endpoint, eventId) => `${endpoint}/minisite_acces.php?id_evenement=${eventId}`),
    new WeezRoute('/channels/print', (endpoint, eventId) => `${endpoint}/canaux_impression.php?id_evenement=${eventId}`),
    new WeezRoute('/finance/transfer_history', (endpoint, eventId) => `${endpoint}/mon_compte_historique.php?event_identity=${eventId}`)
];

export default routes;
